import useStateStore from 'services/store';
import './select-fabric-form.scss';

const SelectFabricForm = () => {
  const {
    activeFabric,
    changeApplyForAll,
    activeProductData,
    changeFabricApplied,
    isShowSelectedFabric,
    changeShowSelectedFabric,
    setActiveFabrics,
  } = useStateStore();

  const handleChangeShowFabrics = (isSelected: string = '') => {
    changeShowSelectedFabric(false);
    if (isSelected) {
      changeFabricApplied(isSelected);
      setActiveFabrics(isSelected);
    } else if (isShowSelectedFabric) {
      changeApplyForAll(false);
    }
  };

  return (
    <div className={`select-fabrics ${isShowSelectedFabric ? '' : 'hide'}`}>
      <div onClick={() => handleChangeShowFabrics()} className="overlay"></div>
      <div className="fabrics-main">
        <div className="header">
          <span onClick={() => handleChangeShowFabrics()} className="cancel">
            <img src="images/cancel.svg" alt="" />
          </span>
        </div>
        <div className="fabrics-container">
          {Object.keys(activeProductData).map((fab, index) => {
            const curProduct = activeProductData[fab];
            return (
              <div
                onClick={() => handleChangeShowFabrics(fab)}
                key={fab}
                className={`fab-container ${
                  activeFabric === fab ? 'active' : ''
                }`}
              >
                <div className="number">{`fabric ${index + 1}`}</div>
                <div className="img">
                  <img src={`${curProduct?.fabric?.img}`} alt="" />
                </div>
                <div className="name">{curProduct?.fabric?.name}</div>
              </div>
            );
          })}
        </div>
        <div className="infor">
          <img src="images/configurator/exclamation.svg" alt="" />
          <div className="text">
            Please select the fabric you want to apply to the other items
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectFabricForm;
